export default {
  modals: 50,
  slides: 20,
  fileSize: 750 // (MB)
}
